import { ColumnDef } from '@tanstack/react-table';
import { ArrowUpDown } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import Routes from '@/router/routes';
import { cn } from '@/lib/utils';

export interface WorkspacesTableProps {
  name: string;
  members: number;
  admins: number;
  date_created: string;
  tellets: number;
  status: string;
}

export const OrganizationWorkspacesColumns = () => {
  const columns: ColumnDef<WorkspacesTableProps>[] = [
    {
      accessorKey: 'name',
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="pl-0"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Name
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      ),
      cell: ({ row }) => (
        <div className="flex items-center gap-3">
          <Link
            className="transition-all ease-in-out hover:text-primary hover:underline"
            to={`${Routes.super_admin_dashboard_single_organization.path}/id`}
          >
            {row?.getValue('name')}
          </Link>
        </div>
      ),
    },
    {
      accessorKey: 'members',
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="pl-0"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Members
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      ),
      cell: ({ row }) => <>{row.getValue('members')}</>,
    },
    {
      accessorKey: 'admins',
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="pl-0"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Admins
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      ),
      cell: ({ row }) => <>{row.getValue('admins')}</>,
    },
    {
      accessorKey: 'date_created',
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="pl-0"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Date created
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      ),
      cell: ({ row }) => <>{row.getValue('date_created')}</>,
    },
    {
      accessorKey: 'tellets',
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="pl-0"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Tellets
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      ),
      cell: ({ row }) => <>{row.getValue('tellets')}</>,
    },
    {
      accessorKey: 'status',
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="pl-0"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Status
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      ),
      cell: ({ row }) => (
        <p
          className={cn(
            row.getValue('status') === 'Shared' &&
              'px-4 text-blue-800 w-fit py-px bg-blue-200 rounded-full',
            row.getValue('status') === 'Private' &&
              'px-5 text-orange-800 w-fit py-px bg-orange-200 rounded-full',
          )}
        >
          {row.getValue('status')}
        </p>
      ),
    },
  ];
  return columns;
};
